import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { PrimaryButton, RoundedButton } from 'shared/buttons';
import { LabelText } from 'shared/components';
import { RoundedRadioButton } from 'shared/inputs';
import { LTV_OPTIONS } from '../constants';
import Info from 'shared/components/Info';

const OptionsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
  
  > * + * {
    margin-left: 6px;
  }

  > label {
    flex-grow: 1;
  }

  ${RoundedButton} {
    min-width: auto;
    padding: 6px;
    text-align: center;
  }

  @media (max-width: 300px) {
    flex-wrap: wrap;
    margin-bottom: 8px;
      
    > label {
      flex-grow: 0;
      width: calc(50% - 3px);
      margin: 0 0 8px;
      
      &:nth-of-type(even) {
        margin-left: 6px;
      }
    }
  }
`;

const SavingButton = styled(PrimaryButton)`
    margin-top: 24px;
    
    @media (max-width: 300px) {
      margin-top: 16px;
    }
`

const FilterView = ({ nhg, setNhg, ltv, setLtv, setShowFilters }) => {
  const setLtvFilter = e => {
    if (e.target.value === 'true') {
      setNhg(true);
    } else {
      setNhg(false);
      setLtv(Number(e.target.value));
    }
  };

  return (
    <>
      <LabelText>
        Tariefklasse
        <Info title="Tariefklasse">
          De tariefklasse is gebaseerd op de verhouding tussen de hypotheek en de marktwaarde van de woning.
          Als je een woning hebt of gaat kopen met Nationale Hypotheek Garantie, val je in de tariefklasse NHG.
        </Info>
      </LabelText>
      <OptionsContainer>
        {LTV_OPTIONS.map(option => (
          <RoundedRadioButton
            key={option.label}
            name="ltv"
            value={option.value}
            checked={nhg ? option.value === nhg : option.value === ltv}
            onChangeHandler={setLtvFilter}
          >
            {option.label}
          </RoundedRadioButton>
        ))}
      </OptionsContainer>
      <SavingButton onClick={() => setShowFilters(false)}>Bekijk rentes</SavingButton>
    </>
  );
};

export default FilterView;

FilterView.propTypes = {
  nhg: PropTypes.bool.isRequired,
  ltv: PropTypes.number.isRequired,
  setNhg: PropTypes.func.isRequired,
  setLtv: PropTypes.func.isRequired,
  setShowFilters: PropTypes.func.isRequired,
};
